/* eslint-disable */
import { createContext } from 'react';
import { IEnaTenantSettings, ITenantLanguages, ITenantProjectionSettings, ITenantStatePreParsed, TenantThemeType } from '@/@types/common';
import { IMapSettings } from '@/@types/common';

// Types
export type TenantContextType = {
  loaded: boolean;
  id: number;
  name: string;
  publicToken: string;
  publicUsername: string;
  tenantTheme: TenantThemeType;
  mapSettings: IMapSettings;
  setTenantData: (data: ITenantStatePreParsed) => void;
  canSearch: boolean;
  canAttributeSearch: boolean;
  canAttributeSearchPublic: boolean;
  projectionSettings: ITenantProjectionSettings[] | null;
  languages: ITenantLanguages[];
  defaultLanguage: string | null;
  ena: IEnaTenantSettings | null;
};

const TenantContext = createContext<TenantContextType | null>(null);
TenantContext.displayName = 'TenantContext';

export default TenantContext;
